import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { OperacaoGarantida } from "./operacao-garantida.model";

export class TrocaIPOCDTO extends BaseEntity {
  public idTrocaIpocScr: number;
  public idOperacaoGarantida: number;
  public dataDesativacao: string;
  public dataBase: string;
  public numeroIpocNovo: number;
  public dataEnvioScrBc: string;
  public tipoAcao: string;
  public dataUltimaAtualizacao: string;
  public tipoIPOC: string;

}

export class DiasAtrasoDTO extends BaseEntity {
  public dataBase: string;
  public numeroDiasAtraso: number;
}

export class ConsultasOperacaoScrDTO extends BaseEntity {
  public dataBase: string;
  public dataEnvio: string;
  public dataRetorno: string;
  public numeroIpoc: number;
  public situacaoConsulta: string;
  public tipoAcao: string;
   public tipoIPOC: string;
}

export const LabelSituacaoConsultaOperacaoScr = [
  {
    nome: 'Enviado',
    codigo: 'C'
  },
  {
    nome: 'Dados carregados',
    codigo: 'P'
  },
  {
    nome: 'Retorno sem dados',
    codigo: 'A'
  },
  {
    nome: 'Não retornado',
    codigo: 'N'
  }
]

export enum TipoConsultaOperacaoSCR {
  MENSAL = 'Mensal',
  EVENTUAL = 'Eventual'
}

export class TipoOcorrenciaSCR  {
  constructor(
    public codigo: string,
    public nome: string,
    public tipoConsultaOperacaoSCR: TipoConsultaOperacaoSCR
  ) {}
}

export const INCLUSAO_IPOC = new TipoOcorrenciaSCR('I', 'Inclusão de IPOC', TipoConsultaOperacaoSCR.MENSAL);
export const TROCA_IPOC =  new TipoOcorrenciaSCR('T', 'Troca de IPOC', TipoConsultaOperacaoSCR.MENSAL);
export const ALTERACAO_DADOS_SCR = new TipoOcorrenciaSCR('A', 'Alteração de dados no SCR', TipoConsultaOperacaoSCR.EVENTUAL)

export const LabelTipoConsultaOperacaoScr: Map<string, string> = new Map ( [
  [INCLUSAO_IPOC.codigo, INCLUSAO_IPOC.tipoConsultaOperacaoSCR],
  [TROCA_IPOC.codigo, TROCA_IPOC.tipoConsultaOperacaoSCR],
  [ALTERACAO_DADOS_SCR.codigo, ALTERACAO_DADOS_SCR.tipoConsultaOperacaoSCR],
])

export const LabelTipoAcao = [
  {
    nome: 'Inclusão',
    codigo: 'I'
  },
  {
    nome: 'Troca',
    codigo: 'T'
  },
  {
    nome: 'Alteração',
    codigo: 'A'
  }
]
export const consultaIpocExemplo =
`I;PEAC;205016165622WQ;;;202206;26425624562562546254625464326-7R03;2022-06-19;
T;PEAC;07745850;;;202205;4534495834FADFASFD987687F;2022-05-06;
A;PEAC;200716165622-4;;;202204;98793443534534534645744363GDFR03;2022-05-02;
O;PEAC;WUY202209099876;;;;;;WUY202209099877
I;PEAC;;89;88888888888;202106;11111111111111111111111111111-1R01;2021-06-30;
T;PEAC;;89;01234567899;202105;56182956819546815481458616481-1R04;2021-07-08;
A;PEAC;;15;77777777777;202104;77777777777777777777777777777-XPTO;2021-05-01;
I;PEAC;;89;88888888888;202106;11111111111111111111111111111-1R01;2021-06-30;;2
T;PEAC;;89;01234567899;202105;56182956819546815481458616481-1R04;2021-07-08;;2
`
